import React from 'react'

const TeamsTournamentComponent = () => {
  return (
    <div>TeamsTournamentComponent</div>
  )
}

export default TeamsTournamentComponent